import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import InfoBanner from '../InfoBanner';
import Modal from '../Modal';
import OpeningHoursInfo from '../OpeningHoursInfo';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-screen">
      <InfoBanner onBannerClick={() => setIsModalOpen(true)} />
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      
      <Modal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        title="Horaires d'Ouverture"
      >
        <OpeningHoursInfo />
      </Modal>
    </div>
  );
};

export default Layout; 